<div class="flex flex-col gap-2">
  <div class="flex flex-col gap-1 text-center text-surface-900 dark:text-surface-0">
    <div class="text-sm font-semibold leading-[22px]" i18n>Agenda del giorno</div>
    <div class="text-xl font-semibold leading-[30px]">{{ date() | date: 'd MMMM y' }}</div>
  </div>

  @if (rows().length === 0) {
    <app-empty-state
      size="small"
      [image]="emptyStateImage"
      i18n-title
      title="Nessuna sessione oggi" />
  } @else {
    <div class="overflow-hidden rounded-md border border-surface-200 bg-surface-0 dark:border-surface-700 dark:bg-surface-900">
      <div
        class="flex h-8 items-center bg-surface-100 px-6 text-sm font-bold capitalize text-surface-900 dark:bg-surface-800 dark:text-surface-0">
        {{ date() | date: 'EEEE' }}
      </div>

      <div class="max-h-48 overflow-auto">
        @for (event of rows(); track event.id) {
          <button
            type="button"
            class="flex w-full cursor-pointer appearance-none border-x-0 border-t-0 border-b border-solid border-surface-200 bg-transparent p-0 text-left text-inherit last:border-b-0 hover:bg-surface-50 dark:border-surface-700 dark:hover:bg-surface-800"
            (click)="onRowClick(event)">
            <span
              class="flex w-20 shrink-0 items-start py-2 pl-6 pr-3 text-xs font-semibold leading-tight text-muted-color">
              @if (event.allDay) {
                <ng-container i18n>Tutto il giorno</ng-container>
              } @else {
                {{ event.start | date: 'HH:mm' }}
              }
            </span>
            <span
              class="flex min-w-0 flex-1 items-start gap-1 border-l border-surface-200 p-2 dark:border-surface-700">
              <span
                class="mt-0.5 size-3 shrink-0 rounded-full"
                [style.background-color]="dotColor(event)"></span>
              <span
                class="min-w-0 text-xs font-normal leading-tight text-surface-900 line-clamp-3 dark:text-surface-0"
                [attr.title]="event.title">{{ event.title }}</span>
            </span>
          </button>
        }
      </div>
    </div>
  }
</div>
